import type { ReactNode } from 'react';
import type { Icon } from '@tabler/icons-react';

interface EmptyStateProps {
  icon: Icon;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-20 text-center">
      <div className="grid h-16 w-16 place-items-center rounded-2xl bg-surface text-muted">
        <Icon className="h-8 w-8" />
      </div>
      <h2 className="mt-4 text-lg font-semibold text-fg">{title}</h2>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-fg-2">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
